// 页面自适应js
$(function(){
	function response(){
		//     分辨率小于960px时, .w 添加 .w-xs
		// 分辨率960px到1210px时, .w 添加 .w-sm
		//分辨率1210px到1390px时, .w 添加 .w-md
		//    分辨率大于1390px时, .w 添加 .w-lg
		$(window).resize(function(){
			var w = $(".w");
			var windowWidth = $(this).width();
			if(windowWidth < 960){
				w.removeClass("w-sm w-md w-lg").addClass("w-xs");
			}else if(windowWidth >=  960 && windowWidth < 1210){
				w.removeClass("w-xs w-md w-lg").addClass("w-sm");
			}else if(windowWidth >= 1210 && windowWidth < 1390){
				w.removeClass("w-xs w-sm w-lg").addClass("w-md");
			}else{
				w.removeClass("w-xs w-sm w-md").addClass("w-lg");
			}
		});
	}
	response();
	// 添加 .sm-hidden 的元素在网页分辨率低于960时会隐藏
	function hideDisplay(){
		//窗口大小改变时,带 .sm-hidden 的元素在窗口小于960px时隐藏,大于960时显示
		var smHidden = $(".t1-sm-hidden");
		$(window).resize(function(){
			var windowWidth = $(this).width();
			if(windowWidth < 960){
				smHidden.css("display", "none")
			}else{
				smHidden.css("display", "block")
			}
		});
	}
	hideDisplay();
	$(window).resize();


	// 设置主体内容区域大小
	// 主体区域有侧边栏时,主体内容宽度 = 主体宽度-侧边栏宽度-20px, 20px是主体内容与侧边栏之间的间距
	function t1SetMainWidthFn(){
		$(window).resize(function() {
			$(".t1-main-content").each(function(){
				var $parent = $(this).parents(".w");
				var $sidebar = $(this).siblings(".t1-main-sidebar");
				if($sidebar && $sidebar.is(":visible")){
					$(this).css("width", ($parent.width() - $sidebar.width() - 20) + "px");
				}else{
					$(this).css("width", $parent.width() - 2 + "px");
				}
			});
		});
		$(window).resize();
	}
	t1SetMainWidthFn();
});